function AdBlockModalEventTriggers(){
    
    $(document).on('click', '.offer-allow-ads', function(e){
        var data = {
            'ge_action' : 'Offer allow ads',
            'ge_category' : 'Adblocker Modal',
            'ge_label' : 'Instructions to disable it',
            'ge_noninteraction' : false
        };
        send_ga_event(data);
    });
    
    $(document).on('click', '.offer-login', function(e){
        var data = {
            'ge_action' : 'Offer Login btn',
            'ge_category' : 'Adblocker Modal',
            'ge_label' : 'To Dashboard',
            'ge_noninteraction' : false
        };
        send_ga_event(data);
    });
    
    $(document).on('click','.offer-buy-ads',function(e){
        var data = {
            'ge_action' : 'Offer Buy Subscription',
            'ge_category' : 'Adblocker Modal',
            'ge_label' : 'To subscriptions Page',
            'ge_noninteraction' : false
        };
        send_ga_event(data);
    });

}

export default AdBlockModalEventTriggers ;

